import { Box, Button, Flex, Text, VStack } from '@chakra-ui/react';
import { useEffect, useState } from 'react'
import DataTable from 'src/components/tables/DataTable';
import { colDefs } from './constants';
import { useNavigate } from 'react-router-dom';
import { disactivePractitioner, getPractitionersByRole } from 'src/view-models/Practitioner';
import Loading from 'src/components/loading/Loading';
import { useAppDispatch, useAppSelector } from 'src/redux/hooks';
import DeleteModal from './components/DeleteModal';
import SearchMedecin from 'src/components/filters/SearchMedecin';

const Dcotors = () => {
  const dispatch = useAppDispatch()
  const navigation = useNavigate()
  const {practitioners:doctors,status} = useAppSelector((state)=>state.practitioner)
  const [isLoading,setIsLoading] = useState(true)
    
  const goToAddPractitioner = () => {
    navigation('/admin/doctors/new')
  }
  useEffect(() => {
    const fetchDoctors = async () => {
      if(status === 1) {
        setIsLoading(true)
        await getPractitionersByRole("medecin",dispatch)
      }else{
        setIsLoading(true)
        await disactivePractitioner("medecin",dispatch)
      }
      setIsLoading(false)
    }
    fetchDoctors()
  }, [status])

  if(isLoading){
    return <Loading />
  }
  
  return (
    <Box  px={4} py={2} rounded={4}  >
      <DeleteModal />
      <Flex height={'100px'} flexDirection={{base:'column',md:'row'}} alignItems={{base:'flex-start',md:'center'}} justifyContent='space-between' gap={4} >
        <Box>
          <Text color='#4E5D78' fontWeight={700} fontSize={30} >Medecins</Text>
          <Text color='#4E5D78'>Sur cette page, vous pouvez gérer tous les aspects concernant Médecins </Text>
        </Box>
        <Button colorScheme='blue' onClick={goToAddPractitioner} >Ajouter Un Médecin</Button>
      </Flex>
      <VStack  alignItems='start' my={4} >
        <SearchMedecin />
        <DataTable columns={colDefs} data={doctors} />
      </VStack>
    </Box>
)
}

export default Dcotors